import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldProps } from '@ngx-formly/core';
import { DatePicker, DatePickerTypeView } from 'primeng/datepicker';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

interface DatepickerFieldProps extends FormlyFieldProps {
  timeOnly?: boolean;
  range?: 'single' | 'multiple' | 'range' | undefined;
  showTime?: boolean;
  appendTo?: boolean;
  showOnFocus?: boolean;
  showIcon?: boolean;
  iconDisplay?: 'input' | 'button' | undefined;
  view?: DatePickerTypeView;
  dateFormat?: string;
}

@Component({
  selector: 'calendar-field',
  standalone: true,
  imports: [...FORM_IMPORTS, DatePicker],
  template: `
    <p-datepicker
      #picker
      class="w-full"
      [class.ng-invalid]="displayError"
      [class.ng-dirty]="displayError"
      [class.p-invalid]="displayError"
      [formControl]="formControl"
      [formlyAttributes]="field"
      autocomplete="false"
      [placeholder]="props.placeholder"
      [appendTo]="props.appendTo ?? 'body'"
      [timeOnly]="props.timeOnly ?? false"
      [showTime]="props.showTime ?? false"
      [selectionMode]="props.range ?? 'single'"
      [showIcon]="props.showIcon == false ? false : true"
      [iconDisplay]="props.iconDisplay ?? 'input'"
      hourFormat="24"
      [view]="props.view ?? 'date'"
      [dateFormat]="props.dateFormat ?? 'dd/mm/yy'"
      [showOnFocus]="props.showOnFocus ?? true"
      (click)="openOnClick(picker)"
    >
      <ng-template #inputicon>
        <i class="fa-regular fa-calendar"></i>
      </ng-template>
    </p-datepicker>
  `,
  styles: `
    :host ::ng-deep .p-datepicker.p-invalid .p-inputtext::placeholder,
    :host ::ng-deep .p-datepicker.p-invalid .p-inputtext.p-placeholder {
      color: var(--p-form-field-invalid-placeholder-color) !important;
      opacity: 1;
    }
  `,
})
export class DatepickerFieldType extends FieldType<
  FieldTypeConfig<DatepickerFieldProps>
> {
  /**
   * `showOnFocus: false` evita che il pannello si apra da solo quando il campo riceve il focus
   * (es. il dialog che si apre mette il focus sul primo campo), ma in PrimeNG disattiva anche
   * l'apertura al click sull'input: qui la si ripristina, così il pannello si apre solo su un
   * click dell'utente. Senza `showOnFocus: false` il comportamento resta quello di PrimeNG.
   */
  openOnClick(picker: DatePicker): void {
    if (this.props.showOnFocus !== false || picker.overlayVisible) return;
    picker.showOverlay();
    picker.cd.markForCheck();
  }

  get displayError(): boolean {
    const submitted = !!this.field.options?.parentForm?.submitted;
    return (
      this.formControl.invalid &&
      (this.formControl.touched || this.formControl.dirty || submitted)
    );
  }
}
